import React from 'react'
import clsx from 'clsx'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

// Child Deps
import MediaImage from './MediaImage'
import MediaVideo from './MediaVideo'

// Styles
import styles from './style.module.scss'

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  cssEase: 'linear',
}

const navSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  focusOnSelect: true,
  arrows: false,
  // responsive: [
  //   {
  //     breakpoint: 767,
  //     settings: 'unslick'
  //   }
  // ]
}

export const MediaGallery = props => {
  const [nav1, setNav1] = React.useState()
  const [nav2, setNav2] = React.useState()
  const [slider1, setSlider1] = React.useState()
  const [slider2, setSlider2] = React.useState()

  React.useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
  }, [slider1, slider2])

  const medias =
    props.data.length > 0
      ? props.data.map(item => {
          let imageType = 'undefined'
          let imageSrc = '/images/dummy-landscape.jpg'

          if (item.image && isEmpty(item.url_embed)) {
            imageType = 'image'
            imageSrc = item.image
          } else {
            imageType = 'video'
            imageSrc = item.url_embed
          }

          return {
            id: item.id,
            type: imageType,
            src: imageSrc,
          }
        })
      : [{ id: '1', type: 'image', src: '/images/dummy-landscape.jpg' }]

  return (
    <div className={clsx(styles.slider_outer)}>
      <div className="slider-outer">
        <Slider
          {...sliderSettings}
          asNavFor={nav2}
          ref={slider => setSlider1(slider)}
          className={clsx('slider-media', styles.slider_media)}
          id="slider-media">
          {medias.map(media => (
            <div key={media.id} className={styles.media_item} id={`image-${media.id}`}>
              {media.type === 'image' ? (
                <MediaImage mediaSrc={media.src} />
              ) : (
                <MediaVideo mediaSrc={media.src} />
              )}
            </div>
          ))}
        </Slider>

        <Slider
          {...navSettings}
          asNavFor={nav1}
          ref={slider => setSlider2(slider)}
          className={clsx('slider-media-nav', styles.slider_media_nav)}
          id="slider-media-nav">
          {medias.map((media, index) => (
            <div
              key={media.id}
              className={styles.media_item}
              id={`image-${media.id}`}
              onClick={() => {
                slider1.slickGoTo(index)
                slider2.slickGoTo(index)
              }}>
              {media.type === 'image' ? (
                <div
                  className={styles.media_wrapper}
                  style={{ backgroundImage: `url(${media.src})` }}>
                  <img
                    src="data:image/gif;base64,R0lGODlhDAAHAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjEgNjQuMTQwOTQ5LCAyMDEwLzEyLzA3LTEwOjU3OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1LjEgV2luZG93cyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMDAyRDQzNTU0N0ExMUVBQTBEOENDRjQ3MzZEQjhDOCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMDAyRDQzNjU0N0ExMUVBQTBEOENDRjQ3MzZEQjhDOCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkEwMDJENDMzNTQ3QTExRUFBMEQ4Q0NGNDczNkRCOEM4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkEwMDJENDM0NTQ3QTExRUFBMEQ4Q0NGNDczNkRCOEM4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAAAsAAAAAAwABwAAAgiEj6nL7Q9VAQA7"
                    alt=""
                  />
                </div>
              ) : (
                <div
                  className={styles.media_wrapper}
                  style={{
                    backgroundImage: `url(https://img.youtube.com/vi/${media.src}/0.jpg)`,
                  }}>
                  <img
                    src="data:image/gif;base64,R0lGODlhDAAHAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjEgNjQuMTQwOTQ5LCAyMDEwLzEyLzA3LTEwOjU3OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1LjEgV2luZG93cyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMDAyRDQzNTU0N0ExMUVBQTBEOENDRjQ3MzZEQjhDOCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMDAyRDQzNjU0N0ExMUVBQTBEOENDRjQ3MzZEQjhDOCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkEwMDJENDMzNTQ3QTExRUFBMEQ4Q0NGNDczNkRCOEM4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkEwMDJENDM0NTQ3QTExRUFBMEQ4Q0NGNDczNkRCOEM4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAAAsAAAAAAwABwAAAgiEj6nL7Q9VAQA7"
                    alt=""
                  />
                </div>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}

MediaGallery.MediaImage = MediaImage
MediaGallery.MediaVideo = MediaVideo
MediaGallery.propTypes = {
  data: PropTypes.array.isRequired,
}

export default MediaGallery
